import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CustomerModel } from '@df/session/api/customer.model';
import { Customer } from '@df/session/api/customer';

@Injectable({
    providedIn: 'root'
})
export class CustomerResolver implements Resolve<CustomerModel> {
    constructor(private customer: Customer) {}

    resolve(): Promise<CustomerModel> {
        return this.customer.model.load();
    }
}
